import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import BlockComponent from './BlockComponent';
import blockDefinition from './definitions/textwithimage.json';

import TextBlock from './Text';
import ImageBlock from './Image';

const propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    description: PropTypes.string,
    quote: PropTypes.string,
    coloredText: PropTypes.bool,
    horizontal: PropTypes.bool,
    picture: PropTypes.object,
    rounded: PropTypes.bool,
    titleOver: PropTypes.bool,
};

const defaultProps = {
    title: 'Title',
    subtitle: null,
    quote: null,
    description: 'Lorem ipsum... .. .... ..',
    coloredText: true,
    horizontal: true,
    rounded: true,
    titleOver: false,
    picture: {
        url: '/img/placeholders/mom.jpg',
    },
};

class TextWithImageBlock extends BlockComponent {

    render() {
        const { picture, horizontal, titleOver, ...props } = this.props;
        const { title, subtitle, description, quote, url, ...imageProps } = props;

        const className = classNames({
            black: true,
            'block-textwithimage': true,
            horizontal,
            'title-over': titleOver,
        });

        if (horizontal) {
            const over = titleOver ? (
                <div className="over">
                    <TextBlock title={title} />
                </div>
            ) : null;
            return (
                <div className={className}>
                    { over }
                    <div className="left">
                        <ImageBlock
                            picture={picture}
                            {...imageProps}
                            lightbox={false}
                            downloadable={false}
                        />
                    </div>
                    <div className="right">
                        <TextBlock {...props} title={!titleOver ? title : null} />
                    </div>
                    <div className="clearfix" />
                </div>
            );
        }

        return (
            <div className="block-textwithimage">
                <ImageBlock
                    picture={picture}
                    {...imageProps}
                    lightbox={false}
                    downloadable={false}
                />
                <TextBlock {...this.props} />
            </div>
        );
    }
}

TextWithImageBlock.propTypes = propTypes;
TextWithImageBlock.defaultProps = defaultProps;
TextWithImageBlock.blockDefinition = blockDefinition;

export default TextWithImageBlock;



// WEBPACK FOOTER //
// ./components/blocks/TextWithImage.jsx